import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import NumberFormat from 'components/number_format';
import moment from 'moment';
import { checkPriceDiffer } from '../../../lib';
import AdItem from './AdItem';
import { toastErrorLogin } from 'helpers/toastHelper';
import { dislikeMarketPrice, likeMarketPrice } from 'actions/gia_ca_thi_truong';
import { useDispatch } from 'react-redux';
import AppContext from 'components/app_context';

const MarketPriceItem = ({ market, priceDifference, tab }) => {
  const { current_user, isMobile } = useContext(AppContext);
  const dispatch = useDispatch();

  const handleLikeMarketPrice = (isLike, marketPriceId) => {
    if (!current_user) {
      toastErrorLogin(isMobile);
      return;
    }

    const action = isLike ? dislikeMarketPrice : likeMarketPrice;
    dispatch(
      action({
        id: current_user.id,
        classable_type: 'MarketPlace',
        classable_id: marketPriceId,
      }),
    );
  };

  const removeItemFromEntity = id => {
    dispatch(
      dislikeMarketPrice({
        id: current_user?.id,
        classable_type: 'MarketPlace',
        classable_id: id,
      }),
    );
  };
  return market?.item_type === 'ad' ? (
    <AdItem ad={market} />
  ) : (
    <div className="lst-item box-link hover p-2 w-100 d-flex flex-column">
      <Link
        to={`/chuyen-muc/thong-tin-gia-ca-thi-truong/${market.slug || market.id}`}
        className="text-decoration-none text-dark"
      >
        <div className="d-flex flex-column flex-md-row align-items-start gap-2">
          {/* Hình ảnh */}
          <div className="flex-shrink-0 text-center">
            <img
              src={market.image ?? '/images/photos/no_image.png'}
              alt={market.title || 'product'}
              title={market.title || 'product'}
              style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: 8 }}
            />
          </div>

          {/* Thông tin sản phẩm */}
          <div className="flex-grow-1 w-100">
            <h6 className="fw-bold mb-1 text-wrap">{market.title}</h6>

            <div className="d-flex flex-wrap justify-content-between mt-2 small text-muted">
              <div className="text-danger fw-bold">
                {market.get_market_price_last?.price > 0 ? (
                  <>
                    <NumberFormat>{market.get_market_price_last.price}</NumberFormat>
                    <span className="fs-7"> đ/{market.unit}</span>
                  </>
                ) : (
                  <span>Liên hệ</span>
                )}
              </div>
              <div className="d-flex align-items-center">
                {priceDifference !== 0 ? (
                  priceDifference < 0 ? (
                    <span className="text-danger d-flex align-items-center font-italic">
                      <img src="/images/down-arrow.png" alt="down arrow" style={{ width: 12, height: 12 }} />
                      <NumberFormat>{checkPriceDiffer(priceDifference)}</NumberFormat>
                      &nbsp;đ/{market.unit}
                    </span>
                  ) : (
                    <span className="text-success d-flex align-items-center font-italic">
                      <img src="/images/incr-arr.png" alt="up arrow" style={{ width: 12, height: 12 }} />+
                      <NumberFormat>{checkPriceDiffer(priceDifference)}</NumberFormat>
                      &nbsp;đ/{market.unit}
                    </span>
                  )
                ) : (
                  <img src="/images/2arr-yel.png" alt="no change" style={{ width: 20, height: 20 }} />
                )}
              </div>
            </div>

            <div className="d-flex flex-wrap justify-content-between mb-1 small text-muted">
              <div>
                <span className="icon-user01 me-1" aria-hidden="true"></span>
                <span>{market.user_name ?? 'Admin'}</span>
              </div>
              <div className="d-flex align-items-center">
                {market.market_place_status_name || '-'}
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-between mb-1 align-items-center small text-muted">
              <div className="d-flex align-items-center">
                <span className="icon-location01 me-1" aria-hidden="true"></span>
                <span>{market.province_name}</span>
              </div>
              <div className="d-flex align-items-center">
                <span className="icon-time me-1" aria-hidden="true"></span>
                {market.last_price_updated_at
                  ? moment(market.last_price_updated_at).format('DD/MM/YYYY h:mm A')
                  : 'Không xác định'}
              </div>
            </div>
          </div>
        </div>
      </Link>

      {/* Like button */}
      <div className="text-end btn-save">
        <a
          role="button"
          className={`icon-tag fs-3 ${market.user_liked ? 'active' : ''}`}
          title="Save"
          onClick={() =>
            tab === 'market-prices-like'
              ? removeItemFromEntity(market.classable_id)
              : handleLikeMarketPrice(market.user_liked, market.classable_id)
          }
        ></a>
      </div>
    </div>
  );
};

export default MarketPriceItem;
